/* Accessoire-productpagina (sections/pf-pdp-acc.liquid): popup "Omschrijving / Specificaties / Verzending en levering / Garantie en retour".
   Zelfde opmaak (.pfp-pop uit pf-pdp-iphone-v3.css) en gedrag als de iPhone-pagina v3 (assets/pf-pdp-iphone-v3.js): rijen met
   data-pfp-open openen het venster op dat onderwerp; tabs met pijltjestoetsen, focusval, Esc en klik naast het venster sluiten,
   focus terug naar de rij. De teksten staan al in de HTML. */
(() => {
  const root = document.querySelector('[data-pfa]');
  if (!root || root.dataset.pfaPopInit) return;
  root.dataset.pfaPopInit = '1';
  const pop = root.querySelector('[data-pfp-pop]');
  if (!pop || typeof pop.showModal !== 'function') return;
  const tabs = [...pop.querySelectorAll('[data-pfp-tab]')], panels = [...pop.querySelectorAll('[data-pfp-panel]')], scroller = pop.querySelector('[data-pfp-scroll]');
  let opener = null;
  function trapTab(e) {
    const f = [...pop.querySelectorAll('a[href], button, input, [tabindex="0"]')].filter(n => !n.disabled && n.tabIndex >= 0 && n.getClientRects().length && !n.closest('[hidden]'));
    if (!f.length) return;
    const k = f.indexOf(document.activeElement), inside = pop.contains(document.activeElement);
    if (e.shiftKey && (k === 0 || !inside)) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && (k === f.length - 1 || !inside)) { e.preventDefault(); f[0].focus(); }
  }
  function show(topic, focusTab) {
    tabs.forEach(b => { const on = b.dataset.pfpTab === topic; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; b.classList.toggle('is-on', on); if (on && focusTab) b.focus(); if (on) b.scrollIntoView({block: 'nearest', inline: 'nearest'}); });
    panels.forEach(p => { p.hidden = p.dataset.pfpPanel !== topic; });
    if (scroller) scroller.scrollTop = 0;
  }
  function open(topic, from) {
    opener = from || null;
    show(topic, false);
    document.documentElement.classList.add('pfp-lock');
    pop.showModal();
    const active = tabs.find(b => b.dataset.pfpTab === topic); if (active) active.focus();
  }
  root.addEventListener('click', e => { const b = e.target.closest('[data-pfp-open]'); if (b) { e.preventDefault(); open(b.dataset.pfpOpen, b); } });
  tabs.forEach(b => b.addEventListener('click', () => show(b.dataset.pfpTab, false)));
  pop.addEventListener('keydown', e => {
    const i = tabs.indexOf(document.activeElement);
    if (i >= 0 && ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'].includes(e.key)) {
      e.preventDefault();
      const n = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      show(tabs[n].dataset.pfpTab, true);
      return;
    }
    if (e.key === 'Tab') trapTab(e);
  });
  pop.addEventListener('click', e => {
    if (e.target.closest('[data-pfp-close]')) { pop.close(); return; }
    if (e.target === pop) { const r = pop.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) pop.close(); }
    if (e.target.closest('[data-pfp-pop-buy]')) pop.close();
  });
  pop.addEventListener('close', () => { document.documentElement.classList.remove('pfp-lock'); if (opener && document.contains(opener) && !document.querySelector('#pf-cart-drawer[open], .pf-cart-drawer.is-open')) opener.focus(); opener = null; });
})();
